import { render } from "./ErrorPageIcon.vue?vue&type=template&id=92dc636c"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ErrorPageIcon.vue"]])

export default __exports__